<template>
  <Modal :title="'删除'+title" v-model="isShow" width="400" :closable="false"
         @on-ok="conformOk"
         @on-cancel="cancel">
    <p>
      确定要删除{{title}}吗？</p>
    <p>删除后无法恢复，请谨慎操作！</p>
  </Modal>
</template>
<script>
export default {
  name: 'modalSure',
  props: ['id', 'title', 'modelApi'],
  data () {
    return {
      isShow: false
    }
  },
  methods: {
    conformOk () {
      this.modelApi(this.id).then(res => {
        this.$Message.success('删除成功')
        this.$emit('closeModal')
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    cancel () {
      this.isShow = false
    },

  }
}
</script>
